import { Pessoa } from '../types/pessoa';

export type GroupFilterType = 'all' | 'fornecedores' | 'clientes' | 'motoristas' | 'transportadoras' | 'bancos' | 'pj' | 'pf';

export const GROUPS_LIST: { id: GroupFilterType; label: string }[] = [
  { id: 'all', label: 'Todos os Grupos' },
  { id: 'fornecedores', label: 'Fornecedores & Prestadores' },
  { id: 'clientes', label: 'Clientes & Obras' },
  { id: 'motoristas', label: 'Motoristas, Ajudantes & Colaboradores' },
  { id: 'transportadoras', label: 'Transportadoras & Fretes' },
  { id: 'bancos', label: 'Bancos & Órgãos Públicos' },
  { id: 'pj', label: 'Todas as Empresas (PJ)' },
  { id: 'pf', label: 'Todas Pessoas Físicas (PF)' },
];

export function pessoaBelongsToGroup(p?: Pessoa | null, group?: GroupFilterType | string): boolean {
  if (!p || !group || group === 'all') return true;

  const catId = Number(p.categoria_cliente_id || 0);
  const tipoId = Number(p.tipo_cliente_id || 0);
  const docDigits = (p.documento || '').replace(/\D/g, '');
  const isPj = tipoId === 2 || docDigits.length > 11;
  const isPf = tipoId === 1 || docDigits.length === 11;
  const text = `${p.nome || ''} ${p.nome_fantasia || ''} ${p.obs || ''}`.toLowerCase();

  if (group === 'pj') return isPj;
  if (group === 'pf') return isPf;

  if (group === 'fornecedores') {
    if (catId === 1) return true;
    const supplierKeywords = ['posto', 'oficina', 'pecas', 'peça', 'comercio', 'distribuidora', 'pneus', 'locacao', 'locadora', 'seguros', 'claro', 'vivo', 'tim', 'della via', 'estacionamento'];
    return supplierKeywords.some(kw => text.includes(kw)) || (isPj && catId !== 2 && catId !== 5 && catId !== 6);
  }

  if (group === 'clientes') {
    if (catId === 2) return true;
    const clientKeywords = ['obra', 'spe', 'residencial', 'empreendimento', 'incorporadora', 'construtora', 'cliente', 'vago'];
    return clientKeywords.some(kw => text.includes(kw));
  }

  if (group === 'motoristas') {
    if (catId === 3 || catId === 4) return true;
    const isCompany = text.includes('engenharia') || text.includes('construtora') || text.includes('incorporadora') || text.includes('comercio') || text.includes('posto') || text.includes('banco') || text.includes('ltda') || text.includes('s.a.') || text.includes('spe') || text.includes('locadora');
    if (isCompany && catId !== 3 && catId !== 4) return false;
    return isPf && catId !== 1 && catId !== 2 && catId !== 5 && catId !== 6;
  }

  if (group === 'transportadoras') {
    if (catId === 5) return true;
    const transKeywords = ['transporte', 'cargas', 'logistica', 'express', 'frete'];
    return transKeywords.some(kw => text.includes(kw));
  }

  if (group === 'bancos') {
    if (catId === 6) return true;
    const bankKeywords = ['banco', 'caixa', 'bradesco', 'itau', 'santander', 'receita', 'prefeitura', 'secretaria', 'fazenda'];
    return bankKeywords.some(kw => text.includes(kw));
  }

  return true;
}
